import React from 'react';
import { X, FileSpreadsheet, ArrowRight, Upload } from 'lucide-react';

export const ImportModal = ({
  STAGES, importStep, sheetUrl, setSheetUrl, sheetPreview,
  columnMap, setColumnMap, importStage, setImportStage,
  importResult, importError, overrideState, setOverrideState,
  overrideDealValue, setOverrideDealValue,
  handlePreviewSheet, handleImportSheet, resetImport,
}) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)' }}
    onClick={(e) => { if (e.target === e.currentTarget) resetImport(); }}>
    <div style={{ width: '95%', maxWidth: '600px', maxHeight: '90vh', background: '#1a1a1a', border: '3px solid #6A0DAD', borderRadius: '12px', boxShadow: '8px 8px 0px 0px #6A0DAD', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '1.25rem', borderBottom: '2px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#6A0DAD', letterSpacing: '0.03em', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FileSpreadsheet size={22} /> Import from Google Sheets
        </h3>
        <button onClick={resetImport} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}><X size={20} /></button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '1.25rem' }}>
        {importError && <div style={{ padding: '0.75rem', background: '#FF3B3020', border: '2px solid #FF3B30', borderRadius: '6px', color: '#FF3B30', fontWeight: 700, marginBottom: '1rem', fontSize: '0.9rem' }}>{importError}</div>}

        {importStep === 'url' && (
          <div>
            <p style={{ color: '#aaa', marginBottom: '1rem', fontWeight: 500 }}>Paste your Google Sheets URL below. The sheet must be shared as <strong style={{ color: '#FFD700' }}>"Anyone with link can view"</strong>.</p>
            <input
              data-testid="sheet-url-input"
              type="url"
              value={sheetUrl}
              onChange={(e) => setSheetUrl(e.target.value)}
              placeholder="https://docs.google.com/spreadsheets/d/..."
              style={{ width: '100%', padding: '0.75rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', marginBottom: '1rem' }}
              onFocus={(e) => e.target.style.borderColor = '#6A0DAD'}
              onBlur={(e) => e.target.style.borderColor = '#333'}
            />
            <button
              data-testid="preview-sheet-btn"
              onClick={handlePreviewSheet}
              disabled={!sheetUrl.includes('docs.google.com/spreadsheets')}
              style={{
                width: '100%', padding: '0.75rem', background: sheetUrl.includes('docs.google.com/spreadsheets') ? '#6A0DAD' : '#333',
                color: '#fff', border: '3px solid #000', borderRadius: '8px', fontWeight: 800,
                textTransform: 'uppercase', cursor: sheetUrl.includes('docs.google.com/spreadsheets') ? 'pointer' : 'not-allowed',
                boxShadow: '3px 3px 0px 0px #000', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
              }}>
              Fetch Sheet <ArrowRight size={18} />
            </button>
          </div>
        )}

        {importStep === 'map' && sheetPreview && (
          <div>
            <p style={{ color: '#aaa', marginBottom: '0.5rem', fontWeight: 500 }}>
              Found <strong style={{ color: '#FFD700' }}>{sheetPreview.total_rows}</strong> rows. Map your columns:
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.25rem' }}>
              {['restaurant_name', 'phone', 'contact', 'email', 'state', 'deal_value'].map(field => (
                <div key={field} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <label style={{ minWidth: '120px', fontWeight: 700, fontSize: '0.85rem', color: '#aaa', textTransform: 'uppercase' }}>
                    {field.replace('_', ' ')}
                    {field === 'restaurant_name' && <span style={{ color: '#FF3B30' }}> *</span>}
                  </label>
                  <select
                    value={columnMap[field] !== undefined ? columnMap[field] : ''}
                    onChange={(e) => setColumnMap({ ...columnMap, [field]: e.target.value === '' ? undefined : parseInt(e.target.value) })}
                    style={{ flex: 1, padding: '0.5rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.9rem', outline: 'none' }}
                  >
                    <option value="">-- Skip --</option>
                    {sheetPreview.headers.map((h, i) => (
                      <option key={i} value={i}>{h}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
              <label style={{ minWidth: '120px', fontWeight: 700, fontSize: '0.85rem', color: '#aaa', textTransform: 'uppercase' }}>Import to</label>
              <select value={importStage} onChange={(e) => setImportStage(e.target.value)}
                style={{ flex: 1, padding: '0.5rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.9rem', outline: 'none' }}>
                {STAGES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
              <label style={{ minWidth: '120px', fontWeight: 700, fontSize: '0.85rem', color: '#aaa', textTransform: 'uppercase' }}>State (all)</label>
              <input type="text" value={overrideState} onChange={(e) => setOverrideState(e.target.value.toUpperCase())} placeholder="e.g. GA" maxLength={2}
                style={{ flex: 1, padding: '0.5rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.9rem', outline: 'none', textTransform: 'uppercase' }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
              <label style={{ minWidth: '120px', fontWeight: 700, fontSize: '0.85rem', color: '#aaa', textTransform: 'uppercase' }}>Deal Value (all)</label>
              <input type="number" value={overrideDealValue} onChange={(e) => setOverrideDealValue(e.target.value)} placeholder="e.g. 297"
                style={{ flex: 1, padding: '0.5rem', background: '#111', border: '2px solid #333', borderRadius: '6px', color: '#fff', fontSize: '0.9rem', outline: 'none' }}
              />
            </div>
            <div style={{ background: '#111', border: '2px solid #333', borderRadius: '8px', overflow: 'auto', marginBottom: '1.25rem', maxHeight: '200px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                <thead>
                  <tr>{sheetPreview.headers.map((h, i) => (
                    <th key={i} style={{ padding: '0.5rem', borderBottom: '2px solid #333', color: '#FFD700', fontWeight: 800, textAlign: 'left', whiteSpace: 'nowrap', textTransform: 'uppercase' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {sheetPreview.preview.map((row, i) => (
                    <tr key={i}>{row.map((cell, j) => (
                      <td key={j} style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid #222', color: '#ccc', whiteSpace: 'nowrap' }}>{cell}</td>
                    ))}</tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button
              data-testid="import-sheet-btn"
              onClick={handleImportSheet}
              disabled={columnMap.restaurant_name === undefined}
              style={{
                width: '100%', padding: '0.75rem',
                background: columnMap.restaurant_name !== undefined ? '#FFD700' : '#333',
                color: '#000', border: '3px solid #000', borderRadius: '8px', fontWeight: 800,
                textTransform: 'uppercase', cursor: columnMap.restaurant_name !== undefined ? 'pointer' : 'not-allowed',
                boxShadow: '3px 3px 0px 0px #000', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
              }}>
              <Upload size={18} /> Import {sheetPreview.total_rows} Deals
            </button>
          </div>
        )}

        {importStep === 'importing' && (
          <div style={{ textAlign: 'center', padding: '3rem 0' }}>
            <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#FFD700', marginBottom: '1rem', letterSpacing: '0.03em' }}>Deploying Missions...</div>
            <div style={{ color: '#aaa', fontWeight: 500 }}>Importing deals from your spreadsheet</div>
          </div>
        )}

        {importStep === 'done' && importResult && (
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <div style={{ fontFamily: "'Bangers', cursive", fontSize: '2.5rem', color: '#22c55e', marginBottom: '0.5rem', letterSpacing: '0.03em' }}>Mission Complete!</div>
            <div style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#FFD700', marginBottom: '1.5rem' }}>
              {importResult.imported} deals imported
            </div>
            <button onClick={resetImport} style={{
              padding: '0.75rem 2rem', background: '#FFD700', color: '#000',
              border: '3px solid #000', borderRadius: '8px', fontWeight: 800,
              textTransform: 'uppercase', cursor: 'pointer', boxShadow: '3px 3px 0px 0px #000',
            }}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
);
